import { useToast } from "@dashboard/library";
import { useTranslation } from "react-i18next";

import { UseGetScorecardsArgs } from "./useGetScorecards.decl";

import { GetScorecards } from "@/graphql/queries/Scorecards";
import { useQueryWrapper } from "@/hooks/useQueryWrapper/useQueryWrapper";

const SCORE_CARD_LIMIT = 1000;

export function useGetScorecards({
  isPublished,
  ID,
  limit = SCORE_CARD_LIMIT,
}: UseGetScorecardsArgs) {
  const { show: showToast } = useToast();
  const { t } = useTranslation();
  const { data, loading } = useQueryWrapper(GetScorecards, {
    variables: { filter: { limit, isPublished, ID } },
    onCompleted: (data) => {
      if (data.getScorecards.__typename !== "PaginatedScoreCards") {
        showToast({
          message: t("error.generic.title"),
          variant: "critical",
        });
      }
    },
    onError: (e) => {
      showToast({
        message: e.message,
        variant: "critical",
      });
    },
  });

  const scorecards =
    data?.getScorecards.__typename === "PaginatedScoreCards"
      ? data.getScorecards.items
      : null;

  return { loading, scorecards };
}
